export default __webpack_public_path__ + "static/product5-002f2eb420364b92a9c9b218367597fa.jpg";